// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_22VkL","BackImage":"_2Y1Xr","Heading":"_3CrTB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BackTo/BackTo.scss
// module id = 2466
// module chunks = 0